import { render, staticRenderFns } from "./DeviceLabel.vue?vue&type=template&id=0c3fea0a&scoped=true"
import script from "./DeviceLabel.vue?vue&type=script&lang=js"
export * from "./DeviceLabel.vue?vue&type=script&lang=js"
import style0 from "./DeviceLabel.vue?vue&type=style&index=0&id=0c3fea0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fea0a",
  null
  
)

export default component.exports